

export function matchesPriceAndRooms(pricesObj, filters) {

    let matchFound = false;

    if (
      !pricesObj ||
      typeof pricesObj !== "object" ||
      Object.keys(pricesObj).length === 0
    ) {
      console.log("⚠️ Пропущен фильтр по ценам — спец-документ или пустые цены");
      return true;
    }


    const parseDeadline = (deadlineStr) => {
      if (!deadlineStr) return Infinity;
      const normalized = deadlineStr.toLowerCase().trim();

      if (normalized.includes("сдан")) return 0;

      const match = normalized.match(/(\d)[^\d]*кв[^\d]*(\d{4})/i);
      if (!match) return Infinity;
      const quarter = parseInt(match[1], 10);
      const year = parseInt(match[2], 10);
      return year * 4 + quarter;
    }; 

    const allDeadlineKeys = Object.keys(pricesObj);
  

      const deadlinesToCheck = filters.deadline
        ? allDeadlineKeys.filter(
            (key) => parseDeadline(key) <= parseDeadline(filters.deadline)
          )
        : allDeadlineKeys;

    
    const parseRoomCount = (type) => {
      if (type === "студия") return 0;
      const match = type.match(/^(\d+)/);
      return match ? parseInt(match[1], 10) : null;
    };
    const selectedRooms = parseRoomCount(filters.rooms);


    for (const deadlineKey of deadlinesToCheck) {
      const offers = pricesObj[deadlineKey] || [];

      for (const offer of offers) {
        const offerRooms = parseRoomCount(offer.type);

        const typeMatch =
          !filters.rooms ||
          (selectedRooms >= 4
            ? offerRooms >= 4
            : offerRooms === selectedRooms);

        const priceMatch =
          (!filters.priceFrom || offer.price_from_mln >= Number(filters.priceFrom)) &&
          (!filters.priceTo || offer.price_from_mln <= Number(filters.priceTo));

        const areaMatch =
          (!filters.areaFrom || offer.area_from_m2 >= Number(filters.areaFrom)) &&
          (!filters.areaTo || offer.area_from_m2 <= Number(filters.areaTo));




        if (typeMatch && priceMatch && areaMatch) {
          matchFound = true;
        }
      }
    }
      if (!matchFound) {
        console.log("❌ Не прошёл фильтр");
      }

      return matchFound;
}

const norm = (s) => String(s || "").trim().toLowerCase();

export function normalizeDeveloper(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/ё/g, "е")
    .replace(/[«»"'.,()]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function isPikDeveloper(value) {
  const developer = normalizeDeveloper(value);
  return developer === "пик"
    || developer === "гк пик"
    || developer === "группа пик";
}

export function isGranelDeveloper(value) {
  const developer = normalizeDeveloper(value);
  return developer === "гранель"
    || developer === "гк гранель"
    || developer === "группа компаний гранель";
}

export function isCurrentClient(complex, clientName) {
  const currentSipClientId = String(complex?.currentSipClientId || "").trim();
  if (!currentSipClientId || !Array.isArray(complex?.sipClients)) return false;

  const currentClient = complex.sipClients.find(
    (client) => String(client?._id || "").trim() === currentSipClientId
  );
  return !!currentClient && norm(currentClient.clientName) === norm(clientName);
}

// Разбираем поле в массив
function toArray(raw) {
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") return raw.split(/[;,|]/);
  return [];
}

// true, если значение — "без отделки" (с вариациями пробелов/дефиса/окончаний)
function isNoneFinish(s) {
  const x = norm(s);
  // матчим "без отделк..." (без отделки/без-отделки/без отделка/без отдел.)
  return /^без[\s-]*отделк/.test(x);
}

// true, если в finishes_available ТОЛЬКО "без отделки" (и ничего больше)
function isOnlyNone(finishesList) {
  const normalized = finishesList.map(norm).filter(Boolean);
  if (normalized.length === 0) return false;         // пусто — не считаем "без отделки"
  const uniq = new Set(normalized);
  return uniq.size === 1 && isNoneFinish([...uniq][0]);
}

const isTrue = (v) => String(v).toLowerCase() === "true" || v === true;
const isEmpty = (v) => v === "" || v === null || v === undefined;
// есть ли ХОТЬ ОДИН активный фильтр (кроме пустых)
function hasAnyActiveFilters(filters) {
  return (
    !isEmpty(filters.priceFrom)     ||
    !isEmpty(filters.priceTo)       ||
    !isEmpty(filters.areaFrom)      ||
    !isEmpty(filters.rooms)         ||
    !isEmpty(filters.finishesMode)  ||
    isTrue(filters.onlyApartments)  
  );
}

export function filterComplexes(complexes, filters, selectedCity) {
  const norm = (s) => String(s || "").trim().toLowerCase();
  const anyFilters = hasAnyActiveFilters(filters);
  return complexes.filter((complex) => {
    if (filters.excludePik && isPikDeveloper(complex.developer)) return false;
    if (filters.excludeGranel && isGranelDeveloper(complex.developer)) return false;
    if (filters?.showYandex !== true && isCurrentClient(complex, "Яндекс")) return false;

    switch (complex.category) {
      case "special":
              // Город (если ты всё ещё хочешь страховку)
        if (selectedCity && complex.city !== selectedCity) return false;

        // Статус
        if (filters.status && String(complex.status) !== filters.status) return false;

        // (опционально) cityCategory
        if (filters.cityCategory) {
          if (!complex.cityCategory || complex.cityCategory !== filters.cityCategory) return false;
        }

        // остальные фильтры (цены/комнаты/отделка) игнорируем — спецам можно
        return true;
      
      case "vehicles": {
        // Город
        if (selectedCity && complex.city !== selectedCity) return false;

        // ✅ Отдельный фильтр отображения vehicles
        if (filters.showVehicles  === false) return false;

        // Статус (как у остальных)
        if (
          filters.status &&
          (!complex.status || String(complex.status) !== filters.status)
        ) return false;

        // cityCategory (если используешь)
        if (filters.cityCategory) {
          if (!complex.cityCategory || complex.cityCategory !== filters.cityCategory) return false;
        }

        // цены/комнаты/отделку не трогаем — как special
        return true;
      }  

      case "commercial": {
        // ✅ Коммерция — фильтруется, если данные есть
        if (anyFilters) return false;
        // Город
        if (selectedCity && complex.city !== selectedCity) return false;

        // Статус
        if (
          filters.status &&
          (!complex.status || String(complex.status) !== filters.status)
        ) return false;
                // Город/область (по полю cityCategory: "city" | "region")
        if (filters.cityCategory) {
          if (!complex.cityCategory || complex.cityCategory !== filters.cityCategory) return false;
        }


        return true;
      }

      case "residential":
      default: {
        // ✅ ЖК и всё остальное — полная фильтрация

        // Город
        if (selectedCity && complex.city !== selectedCity) return false;

        // Статус
        if (
          filters.status &&
          (!complex.status || String(complex.status) !== filters.status)
        ) return false;

        // Застройщик
        if (
          filters.developer &&
          (!complex.developer ||
            !complex.developer.toLowerCase().includes(filters.developer.toLowerCase()))
        ) return false;

        // 🔹 Отделка
        if (filters.finishesMode === "none" || filters.finishesMode === "with") {
          const rawFinishes = complex.finishes_available ?? [];
          const finishesList = toArray(rawFinishes);

          const onlyNone = isOnlyNone(finishesList);
          const hasAnyWith = finishesList.some((v) => !isNoneFinish(v));

          if (filters.finishesMode === "none") {
            if (!onlyNone) {
              console.log("🚫 Отделка: ожидали ТОЛЬКО 'без отделки'", {
                complex: complex.name,
                finishes: finishesList.map(norm).join(", ")
              });
              return false;
            }
          } else { // 'with'
            if (!hasAnyWith) {
              console.log("🚫 Отделка: ожидали ЛЮБУЮ, кроме 'без отделки'", {
                complex: complex.name,
                finishes: finishesList.map(norm).join(", ")
              });
              return false;
            }
          }
        }

        // Цена и комнаты
        const priceAndRoomsMatch = matchesPriceAndRooms(complex.prices, filters);
        if (!priceAndRoomsMatch) return false;

        // Город/область (по полю cityCategory: "city" | "region")
        if (filters.cityCategory) {
          if (!complex.cityCategory || complex.cityCategory !== filters.cityCategory) return false;
        }

        // Только коммерция: отсекаем жилые, если включено
        if (isTrue(filters.onlyCommercial)) {
          return false; // residential пропускаем мимо
        }

        // Только апартаменты: оставляем только isApartments = true
        if (isTrue(filters.onlyApartments)) {
          const apt = isTrue(complex.isApartments);
          if (apt) return false;
        }    

        return true;
      }
    }
  });
}
